import React from "react";

import { CardLabel } from "@src/components/card_label/index";
import { Card, Flex } from "antd";
import "./standard_role_information_card.less";

export interface StandardRoleInformationCardProps {
  basicRoleName: string;
  roleSpecificationName: string;
  teamLeadName: string;
}

const StandardRoleInformationCard: React.FC<
  StandardRoleInformationCardProps
> = ({ basicRoleName, roleSpecificationName, teamLeadName }) => {
  return (
    <Card title="Role" className="info-card standard-role-information-card">
      <Flex vertical gap={16}>
        <CardLabel label="Standard Role">{basicRoleName}</CardLabel>
        <CardLabel label="Role Specification">
          {roleSpecificationName}
        </CardLabel>
        <CardLabel label="Responsible Team Lead">{teamLeadName}</CardLabel>
      </Flex>
    </Card>
  );
};

export default StandardRoleInformationCard;
